import { ById, Participant } from '../services/backendService/types';

export const createParticipantList = (participants: ById<Participant>) => {
  //sort the participants alphabetically by Name
  const sortedParticipants = Object.values(participants)
    .filter(p => !p.isKicked)
    .sort((a, b) => (a.name || a.nickName).localeCompare(b.name || b.nickName));

  return sortedParticipants;
};
